import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-marker-icon-church",
  "use": "spr-marker-icon-church-usage",
  "viewBox": "0 0 26 27",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 27\" id=\"spr-marker-icon-church\"><path fill-rule=\"evenodd\" fill=\"#FFF\" d=\"M25 27H1a1 1 0 1 1 0-2h3v-7a1 1 0 0 1 .4-.8L8 14.5v-4.499l4-2.402V4h-2V2h2V0h2v2h2v2h-2v3.599l4 2.402V14.5l3.6 2.7a1 1 0 0 1 .4.8v7h3a1 1 0 1 1 0 2zM8 17l-2 1.5V25h2v-8zm8-5.867l-3-1.801-3 1.801V25h2v-7h2v7h2V11.133zm4 7.367L18 17v8h2v-6.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/marker-icon-church.svg
// module id = 263
// module chunks = 0